import { FaRegUserCircle } from 'react-icons/fa';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import { RiCalendarScheduleFill } from "react-icons/ri";
import './ViewQuerySchedule.css';
import { FaPersonDigging } from 'react-icons/fa6';
import { Icons } from '../../../../../utils/GlobalIcons';
import ActionButton from '../../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomTextArea from '../../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import { getUserData } from '../../../../../utils/localStorage';

const ViewQueryModal = ({ queryInfo = {}, handleSave, isButtonDisabled }) => {
    const userData = getUserData();

    const formik = useFormik({
        initialValues: {
            reply_text: "",
        },
        validationSchema: Yup.object({
            reply_text: Yup.string().required("Reply is required"),
        }),
        enableReinitialize: true,
        onSubmit: (values) => {
            handleSave(values, queryInfo?.query_id);
        },
    });

    return (
        <div className="query-card-container">

            {/* Header Details */}
            <div className="query-card-section">
                <div className="query-row">
                    <FaPersonDigging className="query-icon" />
                    <div>
                        <div className="query-label">Worksite</div>
                        <div className="query-value">{queryInfo.worksite_name || 'Not Available'}</div>
                    </div>
                </div>

                <div className="query-row">
                    <RiCalendarScheduleFill className="query-icon" />
                    <div>
                        <div className="query-label">Schedule</div>
                        <div className="query-value">{queryInfo.schedule_code || 'Not Available'}</div>
                    </div>
                </div>

                <div className="query-row">
                    <FaRegUserCircle className="query-icon" />
                    <div>
                        <div className="query-label">Sent By</div>
                        <div className="query-value">{queryInfo.submitted_by || 'Not Available'}</div>
                    </div>
                </div>

                <div className="query-row">
                    <Icons.Workforce className="query-icon" />
                    <div>
                        <div className="query-label">Sent To</div>
                        <div className="query-value">{queryInfo.send_to || 'Not Available'}</div>
                    </div>
                </div>

                {/* <div className="query-row">
                    <CgCalendarDates className="query-icon" />
                    <div>
                        <div className="query-label">Date</div>
                        <div className="query-value">{queryInfo.submitted_on || 'Not Available'}</div>
                    </div>
                </div> */}
            </div>

            {/* Chat-like Conversation */}
            <div className="query-chat-container">
                {/* Submitted Query */}
                <div className="chat-bubble chat-left">
                    <div className="chat-author">{queryInfo.submitted_by}</div>
                    <div className="chat-message">{queryInfo.query_text}</div>
                    <div className="chat-time">{queryInfo.submitted_on}</div>
                </div>

                {/* Reply if exists */}
                {queryInfo.reply_text && (
                    <div className="chat-bubble chat-right">
                        <div className="chat-author">{queryInfo.replied_by}</div>
                        <div className="chat-message">{queryInfo.reply_text}</div>
                        <div className="chat-time">{queryInfo.replied_on}</div>
                    </div>
                )}
            </div>

            {/* Reply Box (only if user is not manager role 4) */}
            {userData?.RoleId !== 4 && queryInfo?.replied_on === null && (
                <div className="query-reply-section">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className="query-form-mid-container">
                                <div className="query-label-container">
                                    <span className="add-query-label">
                                        Reply
                                    </span>
                                </div>
                                <div className="query-custom-textfield-container">
                                    <CustomTextArea
                                        id="reply_text"
                                        name="reply_text"
                                        placeholder="Enter your reply"
                                        rows={5}
                                        value={formik.values.reply_text}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.reply_text && Boolean(formik.errors.reply_text)}
                                        helperText={formik.touched.reply_text && formik.errors.reply_text}
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                    <div className="query-form-bottom-action-buttons-container">
                        <ActionButton
                            label="Reset"
                            btnType="outlined"
                            onClick={() => formik.resetForm()}
                        />
                        <ActionButton
                            onClick={formik.handleSubmit}
                            btnDisable={isButtonDisabled}
                            label="Submit Reply"
                            btnType="primary"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewQueryModal;
